import React from "react";
import EvaEntityDetail from "modules/eva/containers/EvaEntityDetail";

interface EvaEntityDetailPageProps {
  isSkillMode?: boolean;
}

const EvaEntityDetailPage: React.FC<EvaEntityDetailPageProps> = ({ isSkillMode = false }) => {
  return <EvaEntityDetail isSkillMode={isSkillMode} />;
};

export default EvaEntityDetailPage;
